import React from 'react';
import { AppRoutes } from './components/AppRoutes';
import './assets/css/custom.css';

export const App: React.FC = () => {
    return (
        <AppRoutes />
    );
};
